export function videoTime(second) {
  const minutes = parseInt(second / 60)
    .toString()
    .padStart(2, 0);
  const seconds = parseInt(second % 60)
    .toString()
    .padStart(2, 0);

  return minutes + ":" + seconds;
}

export function readXlsxFile(file) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onload = (event) => {
      try {
        const workbook = window.XLSX.read(event.target.result, {
          type: "binary",
        });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const data = window.XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        resolve(data);
      } catch (error) {
        reject(error);
      }
    };
    fileReader.readAsBinaryString(file);
  });
}
